import ViewController from "core/views/view.controller";
import {VehiclesFilter} from "../../services/vehicles.service";
import {Screen} from "../../../core/util/screen";

export default class ScanTagCtrl extends ViewController {
    static $inject = ['$scope', '$state', 'Vehicles'];

    constructor() {
        super(...arguments);
        this.plate = null;
        this.scanInProgress = false;
        this.scanNoResult = false;
        this.vehicles = [];
        this.lastVehicles = [];

        this.cameraOptions = {
            cameraX: 15,
            cameraY: 69,
            cameraWidth: window.innerWidth - 30,
            cameraHeight: 290
        };

        this.scanOptions = {
            country: 'eu',
            topN: 1
        };
    }

    $onViewBeforeEnter() {
        this.resetScan();
    }

    $onViewAfterEnter() {
        let self = this;

        Alpr.startCamera(this.cameraOptions, () => {
            Alpr.startRecognizeFromCamera(self.scanOptions, (result) => {
                self.onRecognizeResult(result);

            }, (error) => {
                console.log(error);
            });

        }, (error) => {
            console.log(error);
        });
    }

    $onViewBeforeLeave() {
        Alpr.stopCamera();
    }

    onRecognizeResult(scanResult) {
        let self = this;

        // console.log("SCAN RESULT");
        // console.log(scanResult);

        if (scanResult.length > 0) {
            self.plate = scanResult[0];

            if (self.plate.numbers.length > 0) {
                self.findVehicle(self.plate).then((vehicles) => {
                    self.vehicles = vehicles.data;

                    if (self.vehicles.length == 0) {
                        self.scanNoResult = true;
                        Alpr.startRecognizeFromCamera(self.scanOptions, (result) => {
                            self.onRecognizeResult(result);
                        });

                    } else if (self.vehicles.length == 1) {
                        let vehicle = self.vehicles[0];
                        self.openVehicleDetails(vehicle);
                        self.addLastVehicle(vehicle);
                    }
                });
            }

        } else {
            self.scanNoResult = true;
        }

        self.scanInProgress = false;
        self.$scope.$apply();
    }

    findVehicle(plate) {
        let tagNumbers = plate.numbers.map((number) => {
            return number.number;
        }).join(" ");

        console.log(tagNumbers);

        let vehicleFilter = new VehiclesFilter();
        vehicleFilter.search = tagNumbers;

        return this.Vehicles.find(vehicleFilter);
    }

    openVehicleDetails(vehicle) {
        this.$state.go('tab.vehicle-details', {
            vehicleId: vehicle.id,
            tagNumber: vehicle.tagNumber
        });
    }

    resetScan() {
        this.plate = null;
        this.scanInProgress = false;
        this.scanNoResult = false;
        this.vehicles = [];
    }

    addLastVehicle(vehicle) {
        if (vehicle == null) {
            return;
        }

        this.lastVehicles = this.lastVehicles.filter((lastVehicle) => {
            return vehicle.id !== lastVehicle.id;
        });

        this.lastVehicles.unshift(vehicle);

        // TODO: Restrict lenght of array
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/views/scantag/scantag.controller.js